module.exports = __webpack_public_path__ + "img/male_B_02.9bdc2df9.png";